import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { Service } from '@yandex-360/global-bar';

interface ServicesState {
    services: Service[];
}

const initialState: ServicesState = {
    services: [],
};

const servicesSlice = createSlice({
    name: 'services',
    initialState,
    reducers: {
        setServices: (state, action: PayloadAction<Service[]>) => {
            state.services = action.payload;
        },
        addService: (state, action: PayloadAction<Service>) => {
            state.services.push(action.payload);
        },
        removeService: (state, action: PayloadAction<Service>) => {
            state.services = state.services.filter(service => service !== action.payload);
        },
    },
});

export const { setServices, addService, removeService } = servicesSlice.actions;
export default servicesSlice.reducer;
